var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolidayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1063_19436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54706 19.9345L7.7647 20.7463H24V19.9345H6.54706ZM15.0708 23.1818H19.9413V23.9936H15.0708V23.1818ZM13.447 21.5581H21.5646V22.37H13.447V21.5581ZM20.0744 12.5054C21.5009 13.932 21.5009 16.245 20.0744 17.6716C18.6477 19.0979 16.3349 19.0979 14.9082 17.6716C13.4818 16.245 13.4818 13.932 14.9082 12.5054C16.3349 11.0789 18.6477 11.0789 20.0744 12.5054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95499 19.4131C6.34902 15.4373 7.78489 10.959 8.14896 6.3324L12.5296 10.7273C13.2211 9.35898 12.9596 7.70157 11.8803 6.61269L11.4943 6.22353C11.2373 5.9651 10.9412 5.74873 10.6169 5.58237L14.6918 5.60059C14.2134 4.14378 12.8562 3.15659 11.3229 3.15024L10.7744 3.1478C10.3828 3.14672 9.99366 3.21068 9.62295 3.33709L12.5455 0.424795C11.1772 -0.26655 9.5202 -0.00510153 8.43134 1.07393L8.04213 1.46016C7.78357 1.71704 7.56721 2.01315 7.40106 2.33755C7.23726 2.01187 7.02344 1.71387 6.76738 1.45439L6.38125 1.06514C5.30264 -0.0237393 3.64808 -0.30014 2.27374 0.378857L5.16901 3.31677C4.79921 3.18733 4.41056 3.11993 4.01878 3.11731L3.47085 3.11502C1.93789 3.10807 0.572335 4.08267 0.0807774 5.53474L4.15599 5.55305C3.83014 5.71655 3.53208 5.93034 3.27275 6.18656L2.88333 6.57279C1.79455 7.65157 1.51822 9.30621 2.19744 10.6806L6.51775 6.424C6.22009 10.8713 4.60772 15.1298 1.88533 18.659C1.27418 18.4852 0.652439 18.351 0.0239896 18.2574L0 23.5337L9.33522 23.5741L9.31741 23.5519C7.8757 21.7745 6.03969 20.3574 3.95499 19.4131ZM2.84341 23.1413L2.0316 23.1376L2.03516 22.3258L2.84683 22.3294L2.84341 23.1413ZM5.28173 22.3403L4.47 22.3367L4.47395 21.5249L5.28579 21.5285L5.28173 22.3403Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1063_19436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayIcon);
export default __webpack_public_path__ + "static/media/holidayIcon.b35ee42041f90bf0d75d1e6d289a94af.svg";
export { ForwardRef as ReactComponent };